// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"9abbf0a8","828":"3ca0467c"}[chunkId] + ".chunk.js";
};